
import React, { useState } from 'react';
import Input from '../../../../../Components/Input';
import uploadIcon from '../../../../../Assets/Icons/upload.png'
import InvoiceOtherSettingsController from '../../../../Controllers/AdminScreens/Invoices/Settings/InvoiceOtherSettingsController';
import Loader from '../../../../../Components/Loader';
import LoadingSkeleton from '../../../../../Components/LoadingSkeleton';


const InvoiceOtherSettingsScreen = ({ bookOpenBalance, overdueDays, loadingSettings, errorSettings, onRefresh }) => {
    const {
        booksOpeningBalance,
        setBooksOpeningBalance,
        overdueSetting,
        setOverdueSetting,
        isEditingBooksOpening,
        isEditingOverdue,
        handleUpdateOpeningBalance,
        handleUpdateOverDue,
        openingBalanceError,
        openingBalanceSuccess,
        openingBalanceLoading,
        overdueError,
        overdueSuccess,
        overdueLoading,
        setIsEditingBooksOpening,
        setIsEditingOverdue,
        bookOpenBalanceError,
        overdueSettingError,
        error,
    } = InvoiceOtherSettingsController(bookOpenBalance, overdueDays, errorSettings, onRefresh);

    return (
        <div style={styles.container}>
            <h2 style={styles.title}>Other Setting</h2>

            <div style={styles.field}>
                <label style={styles.label}>Books Opening Balance</label>
                {isEditingBooksOpening ? (
                    <Input
                        value={booksOpeningBalance}
                        onChange={(e) => setBooksOpeningBalance(e.target.value)}
                        searchBoxWidth={220}
                        errorMessage={bookOpenBalanceError}
                        inputType='number'
                    />
                ) : (
                    <div>
                        <span style={styles.value}>{loadingSettings ? (<LoadingSkeleton width="100px" height="15px" />) : (<span>{booksOpeningBalance}</span>)}</span>
                    </div>
                )}
            </div>
            <div className="button-container" style={{ gap: "10px" }}>
                {isEditingBooksOpening ? (
                    <>
                        <button className='add-client-button' onClick={handleUpdateOpeningBalance}
                            style={{ ...styles.updateButton, paddingLeft: 30, paddingRight: 30, opacity: openingBalanceLoading ? 0.5 : 1, cursor: openingBalanceLoading ? 'not-allowed' : 'pointer', }} disabled={openingBalanceLoading}>
                            <span style={{ paddingRight: openingBalanceLoading ? 10 : 0 }}><Loader loading={openingBalanceLoading} color={'#FFFFFF'} size='small' /></span>
                            Update
                        </button>
                        <button style={styles.cancelButton} onClick={() => { setIsEditingBooksOpening(false); }}>
                            Cancel
                        </button>
                    </>
                ) : (
                    <button className='add-client-button' onClick={() => setIsEditingBooksOpening(true)}
                        style={{ marginTop: '50px', paddingLeft: 30, paddingRight: 30, opacity: loadingSettings ? 0.5 : 1, cursor: loadingSettings ? 'not-allowed' : 'pointer', }} disabled={loadingSettings}>
                        Edit
                    </button>
                )}
                {openingBalanceError && <div className="list-error-msg" style={{ marginBottom: '3px' }}> {openingBalanceError} </div>}
                {openingBalanceSuccess && <div className="list-success-msg" style={{ marginBottom: '3px' }}>{openingBalanceSuccess} </div>}
            </div>

            {/* Overdue Setting */}
            <div style={{ ...styles.field, marginTop: '50px' }}>
                <label style={styles.label}>Overdue Setting</label>
                {isEditingOverdue ? (
                    <Input
                        value={overdueSetting}
                        onChange={(e) => setOverdueSetting(e.target.value)}
                        searchBoxWidth={220}
                        errorMessage={overdueSettingError}
                        inputType='number'
                    />
                ) : (
                    <div>
                        <span style={styles.value}>{loadingSettings ? (<LoadingSkeleton width="100px" height="15px" />) : (<span>{overdueSetting}</span>)}</span>
                    </div>
                )}
            </div>
            <div className="button-container" style={{ gap: "10px" }}>
                {isEditingOverdue ? (
                    <>
                        <button className='add-client-button' onClick={handleUpdateOverDue} style={{ ...styles.updateButton, paddingLeft: 30, paddingRight: 30, opacity: overdueLoading ? 0.5 : 1, cursor: overdueLoading ? 'not-allowed' : 'pointer', }} disabled={overdueLoading}>
                            <span style={{ paddingRight: overdueLoading ? 10 : 0 }}><Loader loading={overdueLoading} color={'#FFFFFF'} size='small' /></span>
                            Update
                        </button>
                        <button style={styles.cancelButton} onClick={() => { setIsEditingOverdue(false); }}>
                            Cancel
                        </button>
                    </>

                ) : (
                    <button className='add-client-button' onClick={() => setIsEditingOverdue(true)}
                        style={{ marginTop: '50px', paddingLeft: 30, paddingRight: 30, opacity: loadingSettings ? 0.5 : 1, cursor: loadingSettings ? 'not-allowed' : 'pointer', }} disabled={loadingSettings}>
                        Edit
                    </button>
                )}
                {overdueError && <div className="list-error-msg" style={{ marginBottom: '3px' }}> {overdueError} </div>}
                {overdueSuccess && <div className="list-success-msg" style={{ marginBottom: '3px' }}>{overdueSuccess} </div>}
            </div>
            {error && <div className="list-error-msg" style={{ marginBottom: '3px' }}> {error} </div>}
        </div>
    );

}

const styles = {
    // container: {
    //   width: "600px",
    //   margin: "0 auto",
    //   fontFamily: "Arial, sans-serif",
    // },
    title: {
        color: 'black',
        fontSize: 18,
        fontFamily: 'Roboto',
        fontWeight: '500',
    },
    field: {
        // display: "flex",
        alignItems: "center",
        marginBottom: "15px",
        marginTop: "15px",
    },
    label: {
        flex: "0 0 200px", // Ensures all labels are the same width
        color: 'black',
        fontSize: '12px',
        fontFamily: 'Roboto',
        fontWeight: '400',
    },
    value: {
        flex: "1",
        fontSize: "14px",
        color: "#333",
        lineHeight: "1.5",
        color: '#192A3E',
    },
    // input: {
    //   flex: "1",
    //   height: "30px",
    //   padding: "5px 10px",
    //   fontSize: "14px",
    //   border: "1px solid #d1d5db",
    //   borderRadius: "4px",
    // },

    addServiceButton: {
        backgroundColor: "transparent",
        border: "1px #858585 solid",
        borderRadius: "5px",
        padding: "8px 12px",
        color: "#40513B",
        cursor: "pointer",
        fontSize: '12px',
        fontFamily: 'Roboto',
        fontWeight: '400',
        borderRadius: '28px',
        // marginBottom:'16px'
        display: "flex", // Use flexbox for alignment
        alignItems: "center", // Vertically align icon and text
        justifyContent: "center",
    },
    icon: {
        width: "12px",
        height: "12px",
        marginRight: "10px",
    },
    cancelButton: {
        display: "flex",
        alignItems: "center",
        backgroundColor: "white",
        color: "var(--button-bg-color)",
        border: "1px solid var(--button-bg-color)",
        padding: "8px 16px",
        borderRadius: '20px',
        cursor: "pointer",
    }
};

export default InvoiceOtherSettingsScreen